function createExplosion(x, y) {
    const container = document.getElementById('firework-container');
    const numberOfParticles = 30; 

    for (let i = 0; i < numberOfParticles; i++) {
        const particle = document.createElement('div');
        particle.classList.add('firework');

        const size = Math.random() * 20 + 10;
        particle.style.setProperty('--size', `${size}px`);

        const rotation = Math.random() * 360;
        particle.style.setProperty('--rotation', `${rotation}deg`);

        const angle = (Math.PI * 2) * (i / numberOfParticles);
        const distance = Math.random() * 200 + 100;
        const offsetX = Math.cos(angle) * distance;
        const offsetY = Math.sin(angle) * distance;
        particle.style.setProperty('--x', `${offsetX}px`);
        particle.style.setProperty('--y', `${offsetY}px`);
        particle.style.left = `${x}px`;
        particle.style.top = `${y}px`;

        const randomHue = Math.random() * 360;
        const color = `hsl(${randomHue}, 100%, 50%)`;
        particle.style.setProperty('--color', color);

        container.appendChild(particle);

        setTimeout(() => {
            container.removeChild(particle);
        }, 1200);
    }
}



export function launchFireworks() {
    const numberOfExplosions = 10;
    const margin = 250; // pour ne pas trop depasser de l'ecran

    for (let i = 0; i < numberOfExplosions; i++) {
        const x = Math.random() * (window.innerWidth - 2 * margin) + margin;
        const y = Math.random() * (window.innerHeight - 2 * margin) + margin;

        setTimeout(() => createExplosion(x, y), i * 200);
    }
}
